import dynamic from "next/dynamic";
import {Link} from "@/components/atoms/link";
import {useContext} from "react";
import {Dictionary} from "@/types/hygiena-types";
import {DictionaryContext} from "@/context/dictionary-context";


export function ParagraphContactUsLocations({paragraph, ...props}) {
  const t = useContext<Dictionary>(DictionaryContext);
  if (!paragraph?.places?.length) return <></>;
  return (
    <div className="paragraph--contact-us-location">
      <div className="container mx-auto py-16 text-center flex gap-3 flex-col">
        <h1>
          {t?.all?.find_us_at ?? 'Find us at these locations'}
        </h1>
        <div className="text-lg text-gray-600">{t?.all?.we_have_offices ?? 'We have offices and teams all around the world.'}</div>
      </div>
      <div className="py-16 text-center flex gap-3 flex-col bg-primary">
        <div className="contact-us-place-items container mx-auto py-8 lg:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-20 gap-y-16 px-6 lg:px-0">
          {paragraph['places'].map(item => (
            <div key={item.id} className="text-left text-white">
              <div className="border-b-white border-b pb-2 mb-2 place-head">
                <div className="text-2xl">
                  {item?.field_place_address?.region_name? (
                    <>{item.field_place_address.region_name}</>
                  ) : <></>}
                </div>
                <div>
                  {item.title}
                </div>
              </div>
              {item?.field_place_address && (
                <address className="not-italic pb-2">
                  {item.field_place_address?.organization && (
                    <div className="font-bold pb-2">{item.field_place_address.organization}</div>
                  )}
                  {item.field_place_address?.address_line1 && (
                    <div>{item.field_place_address.address_line1}</div>
                  )}
                  {item.field_place_address?.address_line2 && (
                    <div>{item.field_place_address.address_line2}</div>
                  )}
                  {item.field_place_address?.postal_code && (
                    // Prefix the state if there is one present and "Display state" is set on the place.
                    <div>
                      {/* Non EU city display. */}
                      {['US', 'MX'].includes(item?.field_place_address?.country_code) && item?.field_place_address?.locality && `${item?.field_place_address?.locality}, `}
                      {item?.field_place_display_state && item?.field_place_address?.state && !item?.field_place_address?.is_eu && `${item.field_place_address.state}, `}
                      {item?.field_place_address?.country_code !== 'US' && item?.field_place_address?.administrative_area && item?.field_place_address?.administrative_area !== item?.field_place_address?.state && `${item?.field_place_address?.administrative_area}, `}
                      {item.field_place_address.postal_code}
                      {/* EU city display. */}
                      {item?.field_place_display_state && item?.field_place_address?.state && item?.field_place_address?.is_eu && ` ${item.field_place_address.state}`}
                    </div>
                  )}
                  {item.field_place_address?.country_code && (
                    <div>{item?.field_place_address?.region_name ?? item?.field_place_address?.country_code}</div>
                  )}
                </address>
              )}
              {item?.field_place_telephone && (
                <div>
                  <Link href={`tel:${item.field_place_telephone}`}>{item.field_place_telephone}</Link>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}